import { Dispatch } from "redux";
import {QuickbetsXActionTypes, QuickbetsXAction} from "../../types/QuickbetX/quickbetXsTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const getQuickbetsXData = (): any => {
    return async (dispatch: Dispatch<QuickbetsXAction>) => {
        try {
            dispatch({ type: QuickbetsXActionTypes.FETCH_QUICKBETS_X_DATA });
            const response = await axios({
                method: 'get',
                url: `/api/quickbetx_cards`,
                withCredentials: false
            });
            dispatch({ type: QuickbetsXActionTypes.FETCH_QUICKBETS_X_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: QuickbetsXActionTypes.FETCH_QUICKBETS_X_DATA_ERROR, payload: errorPayload });
        }
    }
}
